export function isCancelledPaymentEntry(entry) {
  return [entry?.status, entry?.orderStatus, entry?.paymentStatus].some((candidate) => (
    ['cancelled', 'canceled', 'canceling'].includes(String(candidate ?? '').trim().toLowerCase())
  ));
}

export function isPaidOrCompletedStatus(status) {
  const normalized = String(status ?? '').trim().toLowerCase();
  return normalized === 'paid' || normalized === 'completed';
}

function isNonEmptyString(value) {
  return typeof value === 'string' && value.trim().length > 0;
}

export function hasVerifiedInvoiceBilling(entry, profileData) {
  const profileBillingInfo = profileData?.auction_bidder_profile?.billing_info ?? null;
  const profileBillingAddress = profileData?.auction_bidder_profile?.billing_address ?? null;
  const billingInfo = entry?.billingInfo ?? profileBillingInfo ?? null;
  const billingAddress = entry?.billingAddress ?? profileBillingAddress ?? null;

  return Boolean(
    billingInfo?.invoice_requested === true
    && billingInfo?.vat_valid === true
    && isNonEmptyString(billingInfo?.vat_id)
    && (isNonEmptyString(billingInfo?.legal_name) || isNonEmptyString(billingInfo?.company_name))
    && isNonEmptyString(billingAddress?.address_street)
    && isNonEmptyString(billingAddress?.address_city)
    && isNonEmptyString(billingAddress?.address_zip_code)
    && isNonEmptyString(billingAddress?.address_country)
  );
}
